module.exports = __webpack_public_path__ + "static/img/7.f25a4bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u_img/7.png
// module id = qzm6
// module chunks = 2